/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */

import React, { useEffect, useState } from "react";
import {
  createContainerFranchise,
  createFranchisePostCode,
  deleteFranchisePostCode,
  franchiseSectorStatus,
  getClassSiteList,
  getSiteList,
} from "../../../_redux/franchises/franchisesCrud";
import {
  fetchFranchisesPostCode,
  fetchFranchisesSectorPostCode,
} from "../../../_redux/franchises/franchisesActions";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import ActiveDialogApi from "../../../../../../_metronic/_partials/widgets/alert/ActiveDialogApiCall";
import DeleteDialogApi from "../franchise-active-dialog/DeleteDialog";
import { Form, Modal } from "react-bootstrap";
import SnackBarTool from "../../../../../../_metronic/_partials/widgets/snack-bar/SnackBar";
import { canvaCancel } from "../../../../../utils/canvaCloseFunction";
import { useFormik } from "formik";
import { FormControl, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getInputClasses, getApiErrorMessage } from "../../../../../utils/commonFunction";
import { InputGroup } from "react-bootstrap";
import DatePicker from "react-datepicker";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import moment from "moment";
import { containerList } from "../../../../Order/_redux/order/orderCrud";
import { fetchContainerFranchise } from "../../../_redux/container/containerAction";

const MAX_CONTAINER_QUANTITY = 100;

/**
 * Off-canvas form for creating franchise containers in bulk.
 *
 * @param {Object} props
 * @param {Object} props.detailData - Franchise detail context
 * @param {boolean} props.dialogCanva - Whether the panel is open
 * @param {Function} props.setDialogCanva - Closes the panel
 * @param {string|number} props.fraId - Franchise id
 * @param {Object} [props.listSort] - The container table's current sort (sort_by / sort_dir), kept when the list reloads
 * @returns {JSX.Element}
 */
export function ContainerCanva({
  detailData,
  dialogCanva,
  setDialogCanva,
  fraId,
  listSort = {},
}) {
  const [snack, setSnack] = useState({ call: false, type: "", message: "" });
  const [dialog, setDialog] = useState({ modal: false });
  const [siteList, setSiteList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [containerDList, setContainerDList] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const roles = useSelector((state) => state.auth.user?.roles || []);
  const isSuperAdmin = roles?.length > 0 && roles.some((role) => role === "super-admin" || role?.name === "super-admin");

  const initialValues = {
    franchise_id: fraId ? fraId : "",
    site_id: "",
    site_class_id: "",
    site_capacity: "",
    container_size: "",
    currently_on_site: 1,
    data: [],
  };

  /**
   * Create the containers, then reload the franchise's container list in the
   * table's current sort.
   *
   * @param {Object} values Form values
   * @param {Object} actions Formik helpers
   */
  const handleSubmit = (values, actions) => {
    setSnack({ call: false, type: "", message: "" });
    if (values.site_id) {
      values.site_capacity = siteList.find(
        (e) => e.id === values.site_id
      )?.capacity;
    }
    if (values.postcode !== "") {
      createContainerFranchise(values)
        .then((res) => {
          //     const data ={
          //       pageNumber:1,
          //       pageSize:20,
          //       franchise_id:fraId    }
          // dispatch(fetchContainerFranchise(data))
          setSnack({ call: true, type: "success", message: res.data.message });
          const data = {
            pageNumber: 1,
            pageSize: 20,
            franchise_id: fraId,
            ...listSort,
          };
          dispatch(fetchContainerFranchise(data));
          // dispatch(fetchFranchisesPostCode(detailData, ""));
          formik.resetForm();
          setTimeout(() => {
            setDialogCanva(false);
          }, 3000);
        })
        .catch((error) => {
          setSnack({
            call: true,
            type: "error",
            message: getApiErrorMessage(error),
          });
        });
    } else {
      formik.resetForm();
      canvaCancel("kt_container_panel_close");
    }
  };

  const handleReset = () => {};

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmit,
    onReset: handleReset,
    validate: (values) => {
      const errors = {};
      const count = Math.max(0, parseInt(values.currently_on_site, 10) || 0);
      if (count > 0) {
        const dataErrors = {};
        for (let index = 0; index < count; index++) {
          const item = values.data && values.data[index] ? values.data[index] : {};
          const itemErrors = {};
          if (!item.reference_unique_id || !String(item.reference_unique_id).trim()) {
            itemErrors.reference_unique_id = "Required";
          }
          if (!item.floor) {
            itemErrors.floor = "Required";
          }
          if (!item.available_from) {
            itemErrors.available_from = "Required";
          }
          if (!item.store_vehicle) {
            itemErrors.store_vehicle = "Required";
          }
          if (!item.vehicle_access) {
            itemErrors.vehicle_access = "Required";
          }
          if (Object.keys(itemErrors).length) {
            dataErrors[index] = itemErrors;
          }
        }
        if (Object.keys(dataErrors).length > 0) {
          errors.data = dataErrors;
        }
      }
      return errors;
    },
  });

  /**
   * Resizes container rows to match the committed quantity.
   *
   * @param {number} count
   * @returns {void}
   */
  const syncDataToQuantity = (count) => {
    const clampedCount = Math.min(
      MAX_CONTAINER_QUANTITY,
      Math.max(0, count),
    );
    const currentData = formik.values.data || [];

    formik.setFieldValue(
      "data",
      Array.from({ length: clampedCount }, (_, index) => ({
        ...(currentData[index] || {}),
        under_maintenance: currentData[index]?.under_maintenance ?? false,
      })),
    );
    formik.setFieldValue("currently_on_site", clampedCount);
  };

  /**
   * Updates quantity input without resizing rows while typing.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event
   * @returns {void}
   */
  const handleQuantityChange = (event) => {
    formik.handleChange(event);
  };

  /**
   * Commits quantity and syncs container rows on blur.
   *
   * @param {React.FocusEvent<HTMLInputElement>} event
   * @returns {void}
   */
  const handleQuantityBlur = (event) => {
    formik.handleBlur(event);
    const count = Number.parseInt(event.target.value, 10) || 0;
    syncDataToQuantity(count);
  };

  const handleSiteList = async () => {
    await getSiteList(fraId).then((res) => {
      setSiteList(res.data.data);
    });
  };
  useEffect(() => {
    if (dialogCanva) handleSiteList();
  }, [dialogCanva]);

  const handleClassList = async (id) => {
    await getClassSiteList(id).then((res) => {
      setClassList(res.data.data);
    });
  };
  useEffect(() => {
    if (formik.values.site_id) {
      handleClassList(formik.values.site_id);
    }
  }, [formik.values.site_id]);

  const handleClose = () => {
    setSearch("");
    formik.resetForm();

    setDialogCanva(false);
  };

  useEffect(() => {
    setLoading(true);
    containerList()
      .then((res) => {
        setContainerDList(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);
  return (
    <Modal
      size="xl"
      fullscreen={true}
      show={dialogCanva}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">Container</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/*end::Header*/}
        <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
          <div className="row">
            <div className="col-md-3 mb-3">
              <Form.Group className="mb-0">
                <Form.Label>Container size</Form.Label>
                <FormControl fullWidth>
                  <Select
                    name="container_size"
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                    className={`form-control  ${getInputClasses(
                      "container_size"
                    )}`}
                    IconComponent={(props) => (
                      <i {...props}>
                        <KeyboardArrowDownIcon />
                      </i>
                    )}
                    inputProps={{ "aria-label": "Without label" }}
                    displayEmpty
                    {...formik.getFieldProps("container_size")}

                    //   onBlur={handleBlur}
                    // value={values.container_size_id}
                  >
                    {loading ? (
                      <MenuItem value="">Loading</MenuItem>
                    ) : (
                      <MenuItem value="">Select</MenuItem>
                    )}
                    {!loading &&
                      containerDList &&
                      containerDList?.length > 0 &&
                      containerDList.map((e) => (
                        <MenuItem key={e.id} value={e.id}>{e.id}</MenuItem>
                      ))}
                  </Select>
                </FormControl>
                {formik.touched.container_size &&
                formik.errors.container_size ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.container_size}
                    </div>
                  </div>
                ) : null}
              </Form.Group>
            </div>

            <div className="col-md-3 mb-3">
              <Form.Group className="mb-0">
                <Form.Label>Site ID</Form.Label>
                <FormControl fullWidth>
                  <Select
                    name="site_id"
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                    className={`form-control  ${getInputClasses("site_id")}`}
                    IconComponent={(props) => (
                      <i {...props}>
                        <KeyboardArrowDownIcon />
                      </i>
                    )}
                    inputProps={{ "aria-label": "Without label" }}
                    displayEmpty
                    {...formik.getFieldProps("site_id")}

                    //   onBlur={handleBlur}
                    // value={values.site_id_id}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {siteList &&
                      siteList.map((e) => (
                        <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>
                      ))}
                  </Select>
                </FormControl>
                {formik.touched.site_id && formik.errors.site_id ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.site_id}</div>
                  </div>
                ) : null}
              </Form.Group>
            </div>
            <div className="col-md-3 mb-3">
              <Form.Group className="mb-0">
                <Form.Label>Class ID</Form.Label>
                <FormControl fullWidth>
                  <Select
                    name="site_class_id"
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                    className={`form-control  ${getInputClasses(
                      "site_class_id",
                    )}`}
                    IconComponent={(props) => (
                      <i {...props}>
                        <KeyboardArrowDownIcon />
                      </i>
                    )}
                    inputProps={{ "aria-label": "Without label" }}
                    displayEmpty
                    {...formik.getFieldProps("site_class_id")}
                    //   onBlur={handleBlur}
                    // value={values.site_class_id_id}
                    disabled={formik.values.site_id === ""}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {classList &&
                      classList.map((e) => (
                        <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>
                      ))}
                  </Select>
                </FormControl>
                {formik.touched.site_class_id && formik.errors.site_class_id ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.site_class_id}
                    </div>
                  </div>
                ) : null}
              </Form.Group>
            </div>
            {/* <div className="col-2 mb-4">
                          <Form.Group className="mb-0">
                            <Form.Label>Collection fee</Form.Label>
                            <FormControl fullWidth>
                              <input
                                type="text"
                                name="price_increase_value"
                                placeholder={"£"}
                                label="External Name"
                                className={`form-control  `}
                                // max={3}
                                // maxLength="3"
                                {...formik.getFieldProps(
                                  "price_increase_value"
                                )}
                              />
                            </FormControl>
                          </Form.Group>
                          {formik.touched.price_increase_value &&
                          formik.errors.price_increase_value ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {formik.errors.price_increase_value}
                              </div>
                            </div>
                          ) : null}
                        </div> */}
            {/* <div className="col-2 mb-4">
                          <Form.Group className="mb-0">
                            <Form.Label>Return fee</Form.Label>
                            <FormControl fullWidth>
                              <input
                                type="text"
                                name="price_increase_value"
                                placeholder={"£"}
                                label="External Name"
                                className={`form-control  `}
                                // max={3}
                                // maxLength="3"
                                {...formik.getFieldProps(
                                  "price_increase_value"
                                )}
                              />
                            </FormControl>
                          </Form.Group>
                          {formik.touched.price_increase_value &&
                          formik.errors.price_increase_value ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {formik.errors.price_increase_value}
                              </div>
                            </div>
                          ) : null}
                        </div> */}
            <div className="col-3 mb-4">
              <Form.Group className="mb-0">
                <Form.Label>Quantity</Form.Label>
                <FormControl fullWidth>
                  <input
                    type="number"
                    name="currently_on_site"
                    placeholder={"Quantity"}
                    label="External Name"
                    className={`form-control  `}
                    value={formik.values.currently_on_site}
                    onChange={handleQuantityChange}
                    onBlur={handleQuantityBlur}
                  />
                </FormControl>
              </Form.Group>
              {formik.touched.price_increase_value &&
              formik.errors.price_increase_value ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    {formik.errors.price_increase_value}
                  </div>
                </div>
              ) : null}
            </div>
            {[
              ...Array(
                Math.max(
                  0,
                  Number.parseInt(formik.values.currently_on_site, 10) || 0,
                ),
              ),
            ].map((_, index) => (
              <div
                key={index}
                className="row mb-3"
                style={{ padding: "2%", margin: "1%", background: "#f3f3f3" }}
              >
                {/* <div className="col-md-1 mb-3">
                  <Form.Group className="mb-0">
                    <Form.Label>Type</Form.Label>
                    <FormControl fullWidth>
                      <Select
                        name={`data.${index}.type`}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                        className={`form-control  ${getInputClasses(
                          `data.${index}.type`
                        )}`}
                        IconComponent={(props) => (
                          <i {...props}>
                            <KeyboardArrowDownIcon />
                          </i>
                        )}
                        inputProps={{ "aria-label": "Without label" }}
                        displayEmpty
                        {...formik.getFieldProps(`data.${index}.type`)}

                        //   onBlur={handleBlur}
                        // value={values.country_id_id}
                      >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="ELE">ELE</MenuItem>
                        <MenuItem value="NON">NON</MenuItem>
                        <MenuItem value="POTENTIAL">POTENTIAL</MenuItem>
                      </Select>
                    </FormControl>
                    {formik.touched.country_id && formik.errors.country_id ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.country_id}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>
                </div> */}
                <div className="col-md-2 mb-3">
                  <Form.Group className="mb-0">
                    <Form.Label>Floor</Form.Label>
                    <FormControl fullWidth>
                      <Select
                        name={`data.${index}.floor`}
                        value={formik.values.data?.[index]?.floor ?? ""}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                        className={`form-control  ${getInputClasses(
                          `data.${index}.floor`,
                        )}`}
                        IconComponent={(props) => (
                          <i {...props}>
                            <KeyboardArrowDownIcon />
                          </i>
                        )}
                        inputProps={{ "aria-label": "Without label" }}
                        displayEmpty
                        onBlur={formik.getFieldProps(`data.${index}.floor`).onBlur}
                        onChange={(e) => {
                          const containerSize = formik.values?.container_size;
                          const data = containerSize ? String(containerSize).split(" ") : [];
                          const cap = data && data.length > 0 ? data[1] : null;
                          const last =
                            cap === "Non-Ele"
                              ? "NON"
                              : cap === "Ele"
                              ? "ELE"
                              : "POTENTIAL";
                          if (cap != null) {
                            formik.setFieldValue(`data.${index}.type`, last);
                          }
                          formik.setFieldValue(
                            `data.${index}.floor`,
                            e.target.value,
                          );
                        }}
                        //   onBlur={handleBlur}
                        // value={values.country_id_id}
                      >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="G">Ground</MenuItem>
                        <MenuItem value="1F">1st</MenuItem>
                        <MenuItem value="2F">2nd</MenuItem>
                      </Select>
                    </FormControl>
                    {formik.errors.data?.[index]?.floor ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.data[index].floor}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>
                </div>

                <div className="col-md-2 mb-3">
                  <Form.Group className="mb-0">
                    <Form.Label>Store vehicle</Form.Label>
                    <FormControl fullWidth>
                      <Select
                        name={`data.${index}.store_vehicle`}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                        className={`form-control  ${getInputClasses(
                          `data.${index}.store_vehicle`,
                        )}`}
                        IconComponent={(props) => (
                          <i {...props}>
                            <KeyboardArrowDownIcon />
                          </i>
                        )}
                        inputProps={{ "aria-label": "Without label" }}
                        displayEmpty
                        {...formik.getFieldProps(`data.${index}.store_vehicle`)}
                        value={formik.values.data?.[index]?.store_vehicle ?? ""}

                        //   onBlur={handleBlur}
                        // value={values.country_id_id}
                      >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="YES">Yes</MenuItem>
                        <MenuItem value="NO">No</MenuItem>
                      </Select>
                    </FormControl>
                    {formik.errors.data?.[index]?.store_vehicle ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.data[index].store_vehicle}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>
                </div>

                <div className="col-md-2 mb-3">
                  <Form.Group className="mb-0">
                    <Form.Label>Vehicle Access</Form.Label>
                    <FormControl fullWidth>
                      <Select
                        name={`data.${index}.vehicle_access`}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                        className={`form-control  ${getInputClasses(
                          `data.${index}.vehicle_access`,
                        )}`}
                        IconComponent={(props) => (
                          <i {...props}>
                            <KeyboardArrowDownIcon />
                          </i>
                        )}
                        inputProps={{ "aria-label": "Without label" }}
                        displayEmpty
                        {...formik.getFieldProps(
                          `data.${index}.vehicle_access`,
                        )}
                        value={formik.values.data?.[index]?.vehicle_access ?? ""}

                        //   onBlur={handleBlur}
                        // value={values.country_id_id}
                      >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="YES">Yes</MenuItem>
                        <MenuItem value="NO">No</MenuItem>
                      </Select>
                    </FormControl>
                    {formik.errors.data?.[index]?.vehicle_access ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.data[index].vehicle_access}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>
                </div>
                <div className="col-2 mb-4">
                  <Form.Group className="mb-0">
                    <Form.Label>Unique&nbsp;ID</Form.Label>
                    <FormControl fullWidth>
                      <input
                        type="text"
                        name={`data.${index}.reference_unique_id`}
                        placeholder={"ID"}
                        label="ID"
                        className={`form-control  `}
                        value={formik.values.data?.[index]?.reference_unique_id ?? ""}
                        onChange={formik.getFieldProps(`data.${index}.reference_unique_id`).onChange}
                        onBlur={formik.getFieldProps(`data.${index}.reference_unique_id`).onBlur}
                      />
                    </FormControl>
                  </Form.Group>
                  {formik.errors.data?.[index]?.reference_unique_id ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.data[index].reference_unique_id}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="col-md-4 mb-5">
                  <Form.Group className="mb-0">
                    <Form.Label>Available from</Form.Label>
                    <InputGroup className={`calendr ${formik.errors.data?.[index]?.available_from ? "is-invalid" : ""}`}>
                      <DatePicker
                        fullWidth
                        fixedHeight
                        className="form-control"
                        wrapperClassName="datepicker"
                        selected={
                          formik.values.data?.[index]?.available_from
                            ? moment(
                                formik.values.data[index].available_from,
                                "YYYY-MM-DD",
                              ).toDate()
                            : null
                        }
                        dateFormat="dd-MM-Y"
                        placeholderText="Select From Date"
                        onChange={(fromDate) => {
                          formik.setFieldValue(
                            `data.${index}.available_from`,
                            fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
                          );
                        }}
                        minDate={new Date()}
                      />
                      <CalendarTodayIcon />
                    </InputGroup>
                    {formik.errors.data && formik.errors.data[index] && formik.errors.data[index].available_from ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block text-danger">
                          {formik.errors.data[index].available_from}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>
                </div>
                <div className="col-md-2 mb-3">
                  <Form.Group className="mb-0">
                    <Form.Label>Room Number</Form.Label>
                    <FormControl fullWidth>
                      <input
                        type="text"
                        name={`data.${index}.container_room_number`}
                        placeholder={"Room Number"}
                        className={`form-control`}
                        value={formik.values.data?.[index]?.container_room_number ?? ""}
                        onChange={formik.getFieldProps(`data.${index}.container_room_number`).onChange}
                        onBlur={formik.getFieldProps(`data.${index}.container_room_number`).onBlur}
                      />
                    </FormControl>
                  </Form.Group>
                </div>
                <div className="col-md-2 mb-3">
                  <Form.Group className="mb-0">
                    <Form.Label>Serial Number</Form.Label>
                    <FormControl fullWidth>
                      <input
                        type="text"
                        name={`data.${index}.container_serial_number`}
                        placeholder={"Serial Number"}
                        className={`form-control`}
                        value={formik.values.data?.[index]?.container_serial_number ?? ""}
                        onChange={formik.getFieldProps(`data.${index}.container_serial_number`).onChange}
                        onBlur={formik.getFieldProps(`data.${index}.container_serial_number`).onBlur}
                      />
                    </FormControl>
                  </Form.Group>
                </div>
                {isSuperAdmin && (
                <div className="col-md-2 mb-3">
                  <Form.Group className="mb-0">
                    <Form.Label>Owned By</Form.Label>
                    <FormControl fullWidth>
                      <Select
                        name={`data.${index}.container_owned_by`}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                        className={`form-control ${getInputClasses(
                          `data.${index}.container_owned_by`,
                        )}`}
                        IconComponent={(props) => (
                          <i {...props}>
                            <KeyboardArrowDownIcon />
                          </i>
                        )}
                        inputProps={{ "aria-label": "Without label" }}
                        displayEmpty
                        {...formik.getFieldProps(`data.${index}.container_owned_by`)}
                        value={formik.values.data?.[index]?.container_owned_by ?? ""}
                      >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value={0}>Not Owned</MenuItem>
                        <MenuItem value={1}>Owned by ESI</MenuItem>
                      </Select>
                    </FormControl>
                  </Form.Group>
                </div>
                )}
                <div className="col-md-3 mb-3 pt-6 d-flex align-items-center">
                  <Form.Group className="mb-0">
                    <Form.Check
                      type="checkbox"
                      id={`under_maintenance_${index}`}
                      label="Under maintenance"
                      checked={formik.values.data?.[index]?.under_maintenance ?? false}
                      onChange={(e) =>
                        formik.setFieldValue(
                          `data.${index}.under_maintenance`,
                          e.target.checked,
                        )
                      }
                    />
                  </Form.Group>
                </div>
              </div>
            ))}
          </div>
        </form>
      </Modal.Body>
      {snack.call ? <SnackBarTool {...snack} /> : ""}
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={() => setDialogCanva(false)}
            className="btn btn-light btn-elevate"
          >
            Close
          </button>
          <> </>

          <button
            type="button"
            className="btn btn-light btn-elevate"
            onClick={() => formik.submitForm()}
          >
            Save
          </button>
        </div>
      </Modal.Footer>
      {/* <ActiveDialogApi
        dialog={dialogSector}
        setDialog={setDialogSector}
        title={"Sector"}
        handleChange={handleChange}
      /> */}
      {/* <DeleteDialogApi
        dialog={dialog}
        setDialog={setDialog}
        title={"Postcode"}
        handleChange={handleDelete}
      /> */}
      {/* {sectorDa.data ? (
        <>
          <EditSector
            type={sectorDa.type}
            data={sectorDa?.data}
            setSectorDa={setSectorDa}
          />
          <div
            className="offcanvas-overlay"
            onClick={() => setSectorDa({ type: "" })}
          ></div>
        </>
      ) : (
        ""
      )} */}
    </Modal>
  );
}
